export const convertToCurrency = (val: number): string =>
  (val / 100).toFixed(2);

export const mapCountryCodeToANZCurrency = (
  countryCode: string,
): 'AUD' | 'NZD' | undefined => {
  switch (countryCode?.toUpperCase()) {
    case 'AU':
      return 'AUD';
    case 'NZ':
      return 'NZD';
    default:
      return undefined;
  }
};
